import { css } from 'emotion'

export const paddingMediumStyles = css`
  padding: 16px;
`
